import React, { useCallback, useEffect, useRef } from "react";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { IconCogAndUser } from "@/Icons";
import LayoutIcon from "@/Components/LayoutIcon";
import { InertiaLink } from "@inertiajs/inertia-react";
import { Inertia } from "@inertiajs/inertia";
import { usePayload } from "@/Contexts/PayloadContext";
import { toast } from "react-toastify";
import SuperUserFormPart from "@/Pages/Superuser/Users/Partials/SuperUserFormPart";

export default function Create() {
  const ref = useRef(null);

  return (
    <form ref={ref} className="flex flex-col gap-4">
      <SuperUserFormPart />
      <Action formRef={ref} />
    </form>
  );
}

Create.layout = (page) => (
  <AppLayout title="New super user">
    <OrganizationLayout
      header="New super user"
      icon={
        <LayoutIcon>
          <IconCogAndUser size={50} className="text-black" />
        </LayoutIcon>
      }
    >
      {page}
    </OrganizationLayout>
  </AppLayout>
);

const Action = ({ formRef }) => {
  const { payload, reset } = usePayload();

  useEffect(() => {
    if (payload?.id) {
      console.log("resetting payload");
      reset();
    }
  }, []);

  const submit = useCallback(
    (e) => {
      e.preventDefault();

      if (isDisabled()) {
        return;
      }

      const id = toast.loading("Please wait...");

      Inertia.post(
        route("admin.users.store"),
        {
          firstname: payload?.firstname,
          surname: payload?.surname,
          email: payload?.email,
          phone: payload?.phone,
        },
        {
          onSuccess: () => {
            reset();
            toast.update(id, {
              render: "Super user created successfully",
              type: "success",
              isLoading: false,
              autoClose: 5000,
            });
          },
          onError: () => {
            toast.update(id, {
              render:
                "An error occurred. Please check your fields and try again.",
              type: "error",
              isLoading: false,
              autoClose: 5000,
            });
          },
        },
      );
    },
    [payload],
  );

  useEffect(() => {
    formRef.current?.addEventListener("submit", submit);
    return () => {
      formRef.current?.removeEventListener("submit", submit);
    };
  }, [formRef, submit]);

  const isDisabled = useCallback(
    () => formRef.current?.checkValidity() !== true,
    [formRef],
  );

  return (
    <div className="mt-4 flex w-full items-center justify-end gap-4">
      <InertiaLink
        className="cursor-pointer text-blue underline hover:no-underline"
        href={route("admin.users")}
      >
        Cancel
      </InertiaLink>
      <button className="btn-blue grow-0" disabled={isDisabled()}>
        Create user
      </button>
    </div>
  );
};
